import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { App, Button, Form, Input, Modal, theme } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { RealCommerceError } from "../../../../exceptions/realCommerceError.js";
import { useStores } from "../../../../store/stores.js";
import { __, _i } from "../../../../utils/i18n.js";
import { useAccountV2ErrorHandling } from "../../hooks/useAccountV2ErrorHandling.js";
const INITIAL_VALUES = {
    purchaseCode: ""
};
// Opens from the "Activate your purchase" card in the Subscriptions tab.
const EnvatoActivationModal = observer(({ open, onClose })=>{
    const { accountV2Store } = useStores();
    const { message } = App.useApp();
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [isBusy, setIsBusy] = useState(false);
    const handleError = useAccountV2ErrorHandling();
    const handleClose = ()=>{
        form.resetFields();
        onClose();
    };
    const onFinish = async ({ purchaseCode })=>{
        setIsBusy(true);
        try {
            const { envatoPurchase: { product: { name: productName } } } = await accountV2Store.createAccountEnvato({
                purchaseCode
            });
            const beforeIds = new Set(accountV2Store.session?.subscriptions.keys() ?? []);
            await accountV2Store.fetchSubscriptionsAndLicenses();
            for (const id of accountV2Store.session?.subscriptions.keys() ?? []){
                if (!beforeIds.has(id)) {
                    accountV2Store.flashSubscription(id, 2400);
                    break;
                }
            }
            message.success(_i(__("Added {{strong}}%s{{/strong}} to your devowl.io account.", productName), {
                strong: /*#__PURE__*/ _jsx("strong", {
                    style: {
                        color: token.colorTextHeading
                    }
                })
            }));
            handleClose();
        } catch (e) {
            if (e instanceof RealCommerceError) {
                handleError(e);
            }
        } finally{
            setIsBusy(false);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        title: /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-modal-head",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-modal-head__title",
                    style: {
                        color: token.colorTextHeading
                    },
                    children: __("Activate codecanyon.net purchase")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-modal-head__subtitle",
                    style: {
                        color: token.colorText
                    },
                    children: __("Connect your codecanyon.net purchase to manage your licenses and activations.")
                })
            ]
        }),
        onCancel: handleClose,
        destroyOnClose: true,
        footer: /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-modal-actions",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    onClick: handleClose,
                    children: __("Cancel")
                }),
                /*#__PURE__*/ _jsx(Button, {
                    type: "primary",
                    loading: isBusy,
                    onClick: ()=>form.submit(),
                    children: __("Add purchase")
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(Form, {
            form: form,
            layout: "vertical",
            initialValues: INITIAL_VALUES,
            onFinish: onFinish,
            children: /*#__PURE__*/ _jsx(Form.Item, {
                name: "purchaseCode",
                label: __("Purchase code (license key)"),
                rules: [
                    {
                        required: true,
                        message: __("Please enter your purchase code.")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Input, {})
            })
        })
    });
});
export { EnvatoActivationModal };
